<!--
 * @Author: wsx
 * @Date: 2022-01-13 15:26:18
 * @LastEditTime: 2022-01-19 17:47:09
 * @LastEditors: your name
 * @Description:数据权限
-->
<template>
  <el-card class="tabs-data-card">
    <template #header>
      <span>数据权限（设置该角色的用户可以操作的数据的范围）</span>
    </template>
    <div class="tabs-data-card-box">
      <table class="tabs-data-card-list">
        <tr class="tabs-data-card-item">
          <td class="label tdFirst">
            <el-radio v-model="radio1" :label="0" size="large">个人</el-radio>
          </td>
          <td class="descr tdFirst">只能操作自己和下属的数据</td>
        </tr>
        <tr class="tabs-data-card-item">
          <td class="label">
            <el-radio v-model="radio1" :label="1" size="large">所属部门</el-radio>
          </td>
          <td class="descr">能操作自己、下属、和自己所属部门的数据</td>
        </tr>
        <tr class="tabs-data-card-item">
          <td class="label">
            <el-radio v-model="radio1" :label="2" size="large">所属部门及下属部门</el-radio>
          </td>
          <td class="descr">所属部门及下属部门 能操作自己、下属和自己所属部门及其子部门的数据</td>
        </tr>
        <tr class="tabs-data-card-item">
          <td class="label">
            <el-radio v-model="radio1" :label="3" size="large">全部</el-radio>
          </td>
          <td class="descr">能操作全部的数据</td>
        </tr>
      </table>
    </div>
  </el-card>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watch
} from 'vue';
import { roleUpdate } from '@/api/system/role.js';
import _ from 'lodash';
import util from '@util/js';
import { ElMessage } from 'element-plus';

export default defineComponent({
  name: 'TabsData',
  components: {},
  props: {

    role: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      radio1: 1,
      flag: false
    });
    const refData = toRefs(state);
    watch(() => props.role, (v) => {
      // 选中角色变化重新加载数据
      if (state.radio1 !== v.type) {
        state.flag = true;
      }
      state.radio1 = v.type;
    });
    watch(() => state.radio1, (v) => {
      if (state.flag) {
        state.flag = false;
      } else {
        roleUpdateAsync(v);
      }
    });
    const roleUpdateAsync = async (type) => {
      console.log("role", props.role, type);
      const form = _.cloneDeep(props.role);
      if (!form.menuIdList) {
        form.menuIdList = [];
      }
      form.type = type;
      util.formatForm(form);
      const res = await roleUpdate(form);
      if (res.code === 0) {
        ElMessage({
          type: 'success',
          message: '设置成功'
        });
        state.dialogVisible = false;
        emit('change', type);
      }
    };
    return { ...refData };
  }
});
</script>
<style  lang='scss' scoped >
.tabs-data-card {
  width: 100%;
  height: 100%;
  .tabs-data-card-box{
    height: 100%;
    width: 100%;
    overflow: auto;
    .tabs-data-card-list{
      width: 100%;
      border-collapse: separate;
      border-spacing: 0;
      .tabs-data-card-item{
        .tdFirst{
          border-top: 1px solid var(--el-border-color-base);
        }
        td{
          border-bottom: 1px solid var(--el-border-color-base);
          padding-left: 10px;
          &.descr{
            border-left: 1px solid var(--el-border-color-base);
          }
        }
      }
    }
  }
}
</style>